export default "__VITE_ASSET__DQY9InW8__"